/*jslint regexp: true, nomen: true, sloppy: true */
/*global require, define, alert, applicationConfig, location, document, window,  setTimeout, Countable */

define('site',['jquery', 'core', 'hammerjs', 'waitForImages', 'bxSlider', 'velocity', 'modal', 'zebraDatepicker', 'autocomplete', 'panzoom', 'form', 'slickJs', 'smartResize'], function ($, core, Hammer) {
    var nua = navigator.userAgent;

    /* Fix iOS 7 bug for -unit support */
    var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i);
    if (iOS) {
        $('html').addClass('outdated-ios');
    }

    var isAndroidChrome = ((nua.indexOf('Mozilla') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1) && (nua.indexOf('Chrome') > -1));

    var module = {};
    var browserSupportsHistoryStateFunctions = !!(window.history && window.history.replaceState);
    var autocompleteCachedListsArray = [];
    var newsletterEmailPosition;
    var savedScrollPosition;

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    function removeLoginAndRegisterFlags() {
        $('.js-checkout-as-guest').addClass('hide-container');

        $('.js-login-checkout-mode').val("False");
        $('.js-login-dressing-room-mode').val("False");
        $('html').removeClass('login-showing');
    }

    function setLoginAndRegisterCheckoutMode() {
        $('.js-checkout-as-guest').removeClass('hide-container');
        $('.js-login-checkout-mode').val("True");
    }

    function setLoginAndRegisterDressingRoomMode() {
        $('.js-login-dressing-room-mode').val("True");
    }

    function showLogin() {
        $('.js-sh-register-section').removeClass('js-active-header-item');
        $('.js-sh-register-section').hide();

        $('.js-sh-login-section').addClass('js-active-header-item sh-login-section-show js-sh-login-section-show');
        $('.js-sh-login-section').show();
        $('.js-site-header').animate({ scrollTop: 0 });
        $('html').addClass('login-showing');
    };

    function showRegister() {
        $('.js-sh-login-section').removeClass('js-active-header-item');
        $('.js-sh-login-section').hide();

        $('.js-sh-register-section').addClass('js-active-header-item sh-login-section-show js-sh-login-section-show');
        $('.js-sh-register-section').show();
        $('.js-site-header').animate({ scrollTop: 0 });
        $('html').addClass('login-showing');
    };

    function closeLoginOrRegister() {
        $('.js-sh-login-section').removeClass('js-active-header-item sh-login-section-show');
        $('.js-sh-login-section').hide();

        $('.js-sh-register-section').removeClass('js-active-header-item sh-login-section-show');
        $('.js-sh-register-section').hide();

        $('html').removeClass('login-showing');
    }

    function closeOpenedActiveMenuItem() {
        if ($('html').hasClass('menu-opened')) {
            $('.js-trigger-menu-resp').first().trigger('click');
        }
        if ($('html').hasClass('login-showing')) {
            closeLoginOrRegister();
        }
    }

    module.onJsActionDoNotPreventDefault = function (context) {
        context.andFind('.js-action-do-not-prevent-default').click(function () {
            core.dom.doAction(this);
        });
    };

    module.shareTriggerWidget = function (context) {
        var self;
        $(context).find('.js-share-trigger').on('click', function (e) {
            e.preventDefault();
            self = $(this);
            if (self.hasClass('active')) {
                self.removeClass('active');
            } else {
                self.addClass('active');
            }
        });
    };

    module.homePageImagesLazyLoad = function () {
        var loadLazyImages = function () {
            var totalTimeout = 0; //To have right loading queue in browser 
            $('.js-hp-lazy-image').each(function () {
                var $element = $(this);
                (function ($localElement, localTimeout) {
                    setTimeout(function () {
                        var imageClass = $localElement.data('lazy-image-class');
                        $localElement.addClass(imageClass);
                    }, localTimeout);
                })($element, totalTimeout);
                totalTimeout += 180;
            });
        };

        var $notLazyLoadImages = $('.js-hp-not-lazy-image');
        if ($notLazyLoadImages.length) {
            $notLazyLoadImages.waitForImages(true).done(loadLazyImages());
        } else {
            loadLazyImages();
        }


    };
    module.customCheckbox = function (context) {
        context.find('.custom-select-list').find('label').on('click', function () {
            $(this).closest('.custom-select-list').siblings('.sub-menu-trigger').attr('checked', false);
        });

    };

    module.homeSliding = function (context) {
        $('.js-scroll-home-section', context).on('click', function () {
            $('html, body').animate({
                scrollTop: $('.page-row').eq(1).offset().top - 58
            }, 300);
        });
    };

    module.mobileNavigation = function (context) {
        var self,
            menuTrigger = $('.js-mobile-menu-trigger', context);

        menuTrigger.on('click', function (e) {
            e.preventDefault();
            self = $(this);
            if (!self.hasClass('active-mobile-item')) {
                $('.active-mobile-item').removeClass('active-mobile-item');
                self.addClass('active-mobile-item');
            } else {
                self.removeClass('active-mobile-item');
            }
        });
    };

    module.detailsImageZoom = function (context) {
        var isZoomingOn = false,
            fadeTime = 100,
            mq;

        if (window.matchMedia) {
            mq = matchMedia('(max-width: 1024px)');
        }

        context.andFind(".details-slide img")
            .off("click") //we have to rebind look details slider on looks slider look change
            .on("click", function (e) {
                e.preventDefault();

                var loadingInContainer = function (container, zIndex) {
                    var $containerLoader = $("<div class='container-loader'><div class='container-spinner'></div><div class='container-spinner-text'>Loading ...</div></div>");
                    if (zIndex) {
                        $containerLoader.css("z-index", zIndex);
                    }
                    container.append($containerLoader);
                    return $containerLoader;
                };

                //mobile
                if (window.matchMedia) {
                    if (mq.matches) {
                        var $originalImg = $(this),
                            $zoomedImgMobile = $('<img src="' + $originalImg.attr("data-src-big") + '" alt="" class="js-zoomed-image" />'),
                            $modal = $('<div class="zoom-modal"></div>'),
                            $loadingArea = $originalImg.parent(),
                            $slideCount = $('.details-slide').length,
                            $modalClose = $('<a href="" class="modal-close fixed js-zoom-modal-close"></a>'),
                            $loadingMobile = loadingInContainer($loadingArea, 12);

                        $zoomedImgMobile
                            .on("load", function () {
                                $loadingMobile.remove();

                                var maxScale = 2,
                                    deviceImageThresholdWidth = 1500,
                                    deviceImageThresholdHeight = 1500,
                                    deviceWidth = $(window).width(),
                                    deviceHeight = $(window).height(),
                                    originalWidth = this.width,
                                    originalHeight = this.height,
                                    width,
                                    height;

                                if (originalWidth / deviceWidth < originalHeight / deviceHeight) {
                                    height = deviceHeight;
                                    width = originalWidth * (deviceHeight / originalHeight);
                                } else {
                                    width = deviceWidth;
                                    height = originalHeight * (deviceWidth / originalWidth);
                                }

                                $zoomedImgMobile
                                    .width(width)
                                    .height(height);

                                if (deviceImageThresholdWidth / width < deviceImageThresholdHeight / height) {
                                    maxScale = deviceImageThresholdWidth / width
                                } else {
                                    maxScale = deviceImageThresholdHeight / height;
                                }

                                if (maxScale < 1) {
                                    maxScale = 1;
                                }

                                $("html").addClass("modal-on");

                                $modal
                                    .append($modalClose)
                                    .append($zoomedImgMobile)
                                    .appendTo($("body"));

                                $zoomedImgMobile.panzoom({
                                    disablePan: false,
                                    increment: 0.5,
                                    minScale: 1,
                                    maxScale: maxScale
                                });

                                var $sliderElement = $(".js-details-slider"),
                                    $detailsSlider = $sliderElement.data("details-slider"),
                                    hammeredImage;

                                //TODO: every image has to be recalculated as if it was loaded in $zoomedImgMobile?
                                //TODO: Hammer detects more then one swipe event (on one physical swipe) sometimes and this loads wrong image
                                hammeredImage = new Hammer($('.zoom-modal')[0]);
                                hammeredImage.off("swipeleft swiperight");
                                if (!$('.only-one-slide').length) {
                                    hammeredImage.on("swipeleft", function (e) {
                                        if (e.type === "swipeleft") {
                                            $('.js-zoom-modal-close').click();
                                            if ($detailsSlider) {
                                                $detailsSlider.goToNextSlide();
                                                setTimeout(function () {
                                                    $('.active-zoom-img').find('img').click();
                                                }, 500);
                                            } else {
                                                $('.js-slider-arrow-right').click();
                                                setTimeout(function () {
                                                    $('.slick-active').not('.individual-look').find('img').click();
                                                }, 500);
                                            }
                                        }
                                    });
                                    hammeredImage.on("swiperight", function (e) {
                                        if (e.type === "swiperight") {
                                            $('.js-zoom-modal-close').click();
                                            if ($detailsSlider) {
                                                $detailsSlider.goToPrevSlide();
                                                setTimeout(function () {
                                                    $('.active-zoom-img').find('img').click();
                                                }, 500);
                                            }
                                            else {
                                                $('.js-slider-arrow-left').click();
                                                setTimeout(function () {
                                                    $('.slick-active').not('.individual-look').find('img').click();
                                                }, 500);
                                            }
                                        }
                                    });
                                }

                                $modal.on('mousewheel.focal', function (e) {
                                    e.preventDefault();
                                    var delta = e.delta || e.originalEvent.wheelDelta;
                                    var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
                                    $zoomedImgMobile.panzoom('zoom', zoomOut, {
                                        increment: 0.1,
                                        animate: false,
                                        focal: e
                                    });
                                });

                                /*
                                $zoomedImgMobile.on('panzoomchange', function () {
                                    console.log($zoomedImgMobile.panzoom("getMatrix"));
                                });*/

                            }).error(function () {
                                core.ui.alert('{ message: \'We are sorry. Zoom image not found.\' }');
                                $loading.remove();
                            });

                        $modalClose.on("click", function (e) {
                            e.preventDefault();
                            $("html").removeClass("modal-on");
                            $modal.remove();
                            $('.container-loader').remove();
                        });
                        return;
                    }
                }

                //desktop
                if (isZoomingOn) {
                    return;
                }
                isZoomingOn = true;

                var $zoomArea = $('<div class="zoom-area"></div>'),
                    $zoomAreaInner = $('<div class="zoom-area-inner"></div>'),
                    $zoomAreaImg = $('<img src="' + $(this).attr("data-src-big") + '" alt=""/>'),
                    $zoomAppendTo = $('.js-zoom-append-area'),

                    $zoomedAreaVisible = $('<div class="zoomed-area-visible"></div>'),
                    $zoomedAreaThumbInner = $(this).parent(),
                    $zoomedAreaThumbImg = $(this),

                    $loading = loadingInContainer($zoomAppendTo, 12);

                $zoomAreaImg.on("load", function () {
                    $loading.remove();
                    $zoomAppendTo
                        .addClass("zoom-img-active");
                    $zoomedAreaVisible
                        .hide()
                        .appendTo($zoomedAreaThumbInner)
                        .fadeIn(fadeTime);
                    $zoomAreaImg.appendTo($zoomAreaInner);
                    $zoomAreaInner.appendTo($zoomArea);
                    $zoomArea
                        .hide()
                        .appendTo($zoomAppendTo)
                        .fadeIn(fadeTime);
                    $('body').addClass('zooming');

                    if ($zoomAreaImg.height() < $zoomArea.height()) {
                        $zoomAreaImg.height($zoomArea.height());
                    }

                    var initZoomWidth = $zoomAreaImg.width(),
                        initZoomHeight = $zoomAreaImg.height(),
                        width = $zoomAreaInner.width() / initZoomWidth,
                        height = $zoomAreaInner.height() / initZoomHeight,
                        left = -parseInt($zoomAreaImg.css("margin-left")) / $zoomAreaInner.width(),
                        top = -parseInt($zoomAreaImg.css("margin-top")) / $zoomAreaInner.height(),
                        visibleWidth = $zoomedAreaThumbImg.width() * width,
                        visibleHeight = $zoomedAreaThumbImg.height() * height,
                        zoom = 1,
                        parentX1 = e.pageX - $zoomedAreaThumbInner.offset().left,
                        parentY1 = e.pageY - $zoomedAreaThumbInner.offset().top,
                        moveTop = -visibleHeight / 2 / zoom + parentY1,
                        moveLeft = -visibleWidth / 2 / zoom + parentX1;

                    if (moveTop < 0) {
                        moveTop = 0;
                    } else if (moveTop + visibleHeight / zoom > $zoomedAreaThumbInner.height()) {
                        moveTop = $zoomedAreaThumbInner.height() - visibleHeight / zoom;
                    }
                    if (moveLeft < 0) {
                        moveLeft = 0;
                    } else if (moveLeft + visibleWidth / zoom > $zoomedAreaThumbInner.width()) {
                        moveLeft = $zoomedAreaThumbInner.width() - visibleWidth / zoom;
                    }

                    $zoomedAreaVisible.css({
                        width: ($zoomedAreaThumbImg.width() * width / zoom),
                        height: ($zoomedAreaThumbImg.height() * height / zoom),
                        top: moveTop,
                        left: moveLeft
                    });
                    var zoomMultiply = 0.5;
                    $zoomAreaImg.css({
                        width: (initZoomWidth * zoom) * zoomMultiply,
                        height: (initZoomHeight * zoom) * zoomMultiply,
                        "margin-left": -(moveLeft / $zoomedAreaThumbInner.width() * $zoomAreaImg.width()) * zoomMultiply + "px",
                        "margin-top": -(moveTop / $zoomedAreaThumbInner.height() * $zoomAreaImg.height()) * zoomMultiply + "px"
                    });

                    $zoomedAreaThumbInner.on("mousemove", function (e) {
                        var parentX1 = e.pageX - $zoomedAreaThumbInner.offset().left,
                            parentY1 = e.pageY - $zoomedAreaThumbInner.offset().top,
                            moveTop = -visibleHeight / 2 / zoom + parentY1,
                            moveLeft = -visibleWidth / 2 / zoom + parentX1;

                        if (moveTop < 0) {
                            moveTop = 0;
                        } else if (moveTop + visibleHeight / zoom > $zoomedAreaThumbInner.height()) {
                            moveTop = $zoomedAreaThumbInner.height() - visibleHeight / zoom;
                        }

                        if (moveLeft < 0) {
                            moveLeft = 0;
                        } else if ($zoomedAreaThumbInner.width() < $zoomedAreaVisible.width()) {
                            moveLeft = 0;
                        } else if (moveLeft + visibleWidth / zoom > $zoomedAreaThumbInner.width()) {
                            moveLeft = $zoomedAreaThumbInner.width() - visibleWidth / zoom;
                        }
                        $zoomedAreaVisible.css({
                            top: moveTop,
                            left: moveLeft
                        });
                        $zoomAreaImg.css({
                            "margin-left": -(moveLeft / $zoomedAreaThumbInner.width() * $zoomAreaImg.width()) + "px",
                            "margin-top": -(moveTop / $zoomedAreaThumbInner.height() * $zoomAreaImg.height()) + "px"
                        });
                    });

                    setTimeout(function () {
                        $("body").on("click.zoomClick", function () {
                            $zoomedAreaVisible.fadeOut(fadeTime, function () {
                                $zoomedAreaVisible.remove();
                            });
                            $zoomArea.fadeOut(fadeTime, function () {
                                $zoomArea.remove();
                            });
                            $('body').removeClass('zooming');
                            $zoomedAreaThumbInner.off("mousemove");
                            $zoomAppendTo
                                .removeClass("zoom-img-active");
                            isZoomingOn = false;
                            $("body").off("click.zoomClick");
                        });
                    }, 10);
                })
                    .error(function () {
                        core.ui.alert('{ message: \'We are sorry. Zoom image not found.\' }');
                        $loading.remove();
                    });
            });
    };

    module.featuredLooksSlider = function (context) {
        var slider = context.find('.js-featured-looks-slider');
        slider
            .on('init', function () {
                $('.looks-carousel-before-init').removeClass('looks-carousel-before-init');
            })
            .on('afterChange', function (slick, currentSlide) {
                $('.active-slide').addClass('active-slide');
                $(currentSlide).addClass('active-slide');
            });

        slider.slick({
            nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
            prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>',
            slidesToShow: 4,
            swipeToSlide: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: '20px',
                    centerMode: true,
                    nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
                    prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>'
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '27%',
                    nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
                    prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>'
                }
            }]
        });
    };

    module.lookItemsSlider = function (context) {
        var lookItemsSlider = context.find('.js-look-items-slider');
        lookItemsSlider.slick({
            nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
            prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>',
            slidesToShow: 1,
            lazyLoad: 'ondemand'
        });
    };

    module.looksInGroupSlider = function (context) {
        var slider = context.find('.js-looks-in-group-slider'),
            slideShowQuant = 4,
            initactiveLookIndex = $('.init-active-look').index(),
            initAciveLookId = $('.init-active-look').data('look-id');
        if ($('.individual-look').length <= 5) {
            $('.look-details-inner').addClass('not-enough-items');
        }
        var filterLookItemsSlider = function (forceAciveLookId) {
            var activeLookId = forceAciveLookId || $('.js-looks-in-group-slider').find('.slick-current').data('look-id');
            var $lookItemsSlider = $('.js-look-items-slider');

            $lookItemsSlider.slick('slickFilter', '[data-look-id="' + activeLookId + '"]');
            module.detailsImageZoom($lookItemsSlider);

            if (!forceAciveLookId) {
                $('.look-description-item.active').removeClass('active').addClass('hide-container');
                $('.look-description-item[data-look-id="' + activeLookId + '"]').addClass('active').removeClass('hide-container');

                $('.js-active-look-title').html($('.individual-look.slick-current > img').attr('alt'));
                $('.js-look-items-slider').slick('slickGoTo', 0, true);
            }

            return activeLookId;
        }

        slider.on('init', function (slick) {
            filterLookItemsSlider(initAciveLookId);
            initAciveLookId = undefined;
        });

        slider.on('click.slick', function () {
            var activeLookId = filterLookItemsSlider();

            var lookDetailsUrlTemplate = $('.js-look-details-url-template').data('url-template');
            if (browserSupportsHistoryStateFunctions) {
                var url = lookDetailsUrlTemplate.replace('99999', activeLookId);
                window.history.replaceState(undefined, '', url);
            }
        });

        var slidesCount = $('.individual-look').length;
        if (slidesCount > 4) {
            slider.slick({
                slidesToShow: slideShowQuant,
                focusOnSelect: true,
                waitForAnimate: false,
                initialSlide: initactiveLookIndex
            });
        } else {
            slider.slick({
                slidesToShow: slidesCount,
                focusOnSelect: true,
                initialSlide: 0
            });

            $('.individual-look').removeClass('slick-current');
            $('.init-active-look').addClass('slick-current');
        }
    };

    module.onLookItemSelected = function (context) {
        function setItemFieldValue(element) {
            var $element = $(element);
            var $itemDetailsContainer = $element.closest('.look-details-container');
            var itemFieldName = $element.data('item-field-name');
            var $itemField = $itemDetailsContainer.andFind('[name="' + itemFieldName + '"]');

            var itemSelectedFieldName = $itemField.data('item-selected-field-name');
            var $itemSelectedField = $('[name="' + itemSelectedFieldName + '"]');
            var isItemSelected = $itemSelectedField.val() == 1;

            var itemSizeFieldName = $itemField.data('item-size-field-name');
            var $itemSizeField = $itemDetailsContainer.andFind('[name="' + itemSizeFieldName + '"]');
            var itemSizeValue = $itemSizeField.val();

            $itemField.val(isItemSelected ? itemSizeValue : "");
        }

        //Item check button
        context.andFind('.js-select-look-item-button').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            var itemSelectedFieldName = $this.data('item-selected-field-name');
            var $itemDetailsContainer = $this.closest('.look-details-container');

            $itemDetailsContainer.toggleClass('selected');
            $('[name="' + itemSelectedFieldName + '"]').val($itemDetailsContainer.hasClass('selected') ? 1 : 0);

            setItemFieldValue(this);

            var $lookContainer = $this.closest('.look-description-item');
            $lookContainer.andFind('.js-select-all-look-items-checkbox')
                .prop('checked', $lookContainer.andFind('.look-details-container.js-available').length == $lookContainer.andFind('.look-details-container.selected').length);

            var lookId = $this.data('look-id');
            var selectedItemsCount = $('.js-look-' + lookId + '-form').children('.look-details-container.selected').length;
            var $selectedlookItemsCountDiv = $lookContainer.find('.js-selected-look-items-text');
            switch (selectedItemsCount) {
                case 0:
                    $selectedlookItemsCountDiv.html($selectedlookItemsCountDiv.data('no-items-text'));
                    break;
                case 1:
                    $selectedlookItemsCountDiv.html($selectedlookItemsCountDiv.data('one-item-text'));
                    break;
                default:
                    $selectedlookItemsCountDiv.html($selectedlookItemsCountDiv.data('many-item-text-template').replace('{0}', selectedItemsCount));
            }
        });

        //Item size dropdown
        context.andFind('.js-look-item-size-dropdown').change(function () {
            var $this = $(this);
            var $itemDetailsContainer = $this.closest('.look-details-container');

            if ($itemDetailsContainer.hasClass('selected') || !$this.val()) {
                setItemFieldValue(this);
            } else {
                $itemDetailsContainer.find('.js-select-look-item-button').click();
            }
        });

        //Select all look items checkbox
        context.andFind('.js-select-all-look-items-checkbox').change(function () {
            var $this = $(this);
            var $lookContainer = $this.closest('.look-description-item');

            if ($this.is(':checked')) {
                var $notSelectedItemDetailsContainers = $lookContainer.children('.look-details-container:not(.selected)');
                $notSelectedItemDetailsContainers.children('.js-select-look-item-button').click();
            } else {
                var $selectedItemDetailsContainers = $lookContainer.children('.look-details-container.selected');
                $selectedItemDetailsContainers.children('.js-select-look-item-button').click();
            }
        });
    }

    module.responsiveMenuTrigger = function () {
        var bodyContainer = $('html'),
            menuTrigger = $('.js-trigger-menu-resp'),
            menuContainerClass = 'menu-active',
            menuBodyClass = 'menu-opened',
            dropdownMenu = $('.js-store-menu-sticky'),
            searchTrigger = $('.js-trigger-search'),
            dropdownSearch = $('.js-store-search-sticky'),
            siteHeader = $('.js-site-header'),
            searchContainerClass = 'search-active',
            searchBodyClass = 'search-opened';

        function openContainer(trigger, container, activeContainerClass, activeBodyClass) {
            if (!trigger.hasClass('js-permanent')) {
                trigger.addClass('active');
            }
            container.addClass(activeContainerClass);
            bodyContainer.addClass(activeBodyClass);
            siteHeader.animate({ scrollTop: 0 }, 0);
        }

        function closeContainer(trigger, container, activeContainerClass, activeBodyClass) {
            if (!trigger.hasClass('js-permanent')) {
                trigger.removeClass('active');
            }
            $('#query').blur();
            container.removeClass(activeContainerClass);
            bodyContainer.removeClass(activeBodyClass);
            $(document).off('click.search-close');
        }

        menuTrigger.on('click', function (e) {
            e.preventDefault();
            var self = $(this);

            if ($('html').hasClass('menu-opened')) {
                closeContainer(self, dropdownMenu, menuContainerClass, menuBodyClass);
            } else {
                closeOpenedActiveMenuItem();

                openContainer(self, dropdownMenu, menuContainerClass, menuBodyClass);
            }
            $('.modal-outfit-creation').find('.modal-close').click();
        });

        searchTrigger.on('click', function (e) {
            e.preventDefault();
            var self = $(this);

            function closeSearch(closeFromMenu) {
                $('.js-shop-search-form').off('click.searchClick');
                $("body").off("click.notSearchClick");

                closeContainer(self, dropdownSearch, searchContainerClass, searchBodyClass);

                $('.js-shop-search-field').blur();
                if (!closeFromMenu) {
                    self.removeClass('active-submenu-header active');
                }
            }

            function addNotSearchFormClickEvent() {
                $('.js-shop-search-form')
                    .off('click.searchClick')
                    .on('click.searchClick', function (e) {
                        e.stopPropagation();
                    });

                $("body")
                    .off("click.notSearchClick")
                    .on("click.notSearchClick", function () {
                        closeSearch(false);
                    });
            }

            if (bodyContainer.hasClass('search-opened')) {
                closeSearch(true);
            } else {
                closeOpenedActiveMenuItem();

                $(".js-shop-search-field").val("");
                $(".js-shop-search-field").focus();

                openContainer(self, dropdownSearch, searchContainerClass, searchBodyClass);

                setTimeout(function () {
                    addNotSearchFormClickEvent();
                }, 0);
            }
        });

        $(".js-close-search").on("click", function (e) {
            e.preventDefault();
            searchTrigger.first().trigger('click');
        });
    };

    module.triggerFooter = function (context) {
        var self,
            pageBody = $('body');
        $('.js-footer-trigger', context).on('click', function () {
            self = $(this);
            if (self.hasClass('active')) {
                self.removeClass('active');
                pageBody.removeClass('footer-expanded');
            } else {
                self.addClass('active');
                pageBody.addClass('footer-expanded');
            }
        });
    };

    module.checkHeaderPos = function () {
        var windowX = $(window).scrollTop(),
            bodyWrap = $('body');
        if (!windowX > 0) {
            bodyWrap.addClass('header-sticked');
        } else {
            bodyWrap.removeClass('header-sticked');
        }
    }

    module.checkHeaderIsSticked = function (context) {
        module.checkHeaderPos();
        $(window).on('scroll', function () {
            module.checkHeaderPos();
        });
    }

    module.checkHomeLogoVisible = function (context) {
        var logo = $('.js-home-logo', context),
            siteHeader,
            headerHeight,
            logoTop,
            windowScrollTop;

        function toggleVisibility() {
            windowScrollTop = $(window).scrollTop();

            if (windowScrollTop > logoTop) {
                siteHeader.addClass('home-logo-is-invisible');
            } else {
                siteHeader.removeClass('home-logo-is-invisible');
            }
        }

        if (logo.length) {
            siteHeader = $('.js-site-header', context);
            headerHeight = $('.sh-outer-line', context).outerHeight();
            logoTop = logo.offset().top + logo.height() - headerHeight;

            toggleVisibility();

            $(window).on('scroll', function () {
                toggleVisibility();
            });

            $(window).smartresize(function () {
                logoTop = logo.offset().top + logo.outerHeight() - headerHeight;

                toggleVisibility();
            });
        }
    };

    module.flyingSidebar = function () {
        //todo multilple sidebars support?
        var $sidebar = $(".js-flying-sidebar"),
            $siteHeader = $(".js-site-header"),
            $siteFooter = $(".js-site-footer"),
            $ignore = $(".js-flying-sidebar-ignore"),
            stickyNavHeight = 56,
            sectionPadding = 40;

        if ($sidebar.length == 0) {
            return;
        }

        $(window).on("scroll", function () {
            var extraIgnoreHeight = 0, //todo margins get ignored OR original offset dependable on parent?
                windowHeight = $(window).height(),
                scrollTop = $(window).scrollTop(),
                footer = 0,
                sidebarOffsetY,
                sidebarOuterHeight = $sidebar.outerHeight(),
                siteFooterOffsetTop = $siteFooter.offset().top,
                siteHeaderHeight = $siteHeader.outerHeight(),
                mq;

            if (window.matchMedia) {
                mq = matchMedia('(max-width: 1024px)');
            }

            $ignore.each(function () {
                extraIgnoreHeight = extraIgnoreHeight + $(this).outerHeight()
            });

            if (window.matchMedia) {
                if (mq.matches) {
                    siteHeaderHeight = 0;
                }
            }

            sidebarOffsetY = siteHeaderHeight + extraIgnoreHeight;

            if (sidebarOuterHeight + sectionPadding + stickyNavHeight > windowHeight) {
                $sidebar.css({
                    top: 0
                });
                return;
            }

            if (scrollTop + stickyNavHeight + sectionPadding + sidebarOuterHeight > siteFooterOffsetTop) {
                footer = scrollTop + stickyNavHeight + sectionPadding + sidebarOuterHeight - siteFooterOffsetTop;
            }

            if (scrollTop > sidebarOffsetY) {
                $sidebar.css({
                    top: scrollTop - sidebarOffsetY - footer
                });
            } else {
                $sidebar.css({
                    top: 0
                });
            }
        });
        $(window).scroll();
    };

    module.flyingToTopButton = function () {
        var $flyingButton = $(".js-flying-to-top-button"),
            $siteHeader = $(".js-site-header"),
            $siteFooter = $(".js-site-footer"),
            showing = false;

        if ($flyingButton.length == 0) {
            return;
        }

        $(window).on("scroll", function () {
            var scrollTop = $(window).scrollTop(),
                footer = 0;

            if (scrollTop + $(window).height() > $siteFooter.offset().top) {
                footer = scrollTop + $(window).height() - $siteFooter.offset().top;
            }

            $flyingButton.css({
                top: scrollTop + $(window).height() - ((210 + footer) + $siteHeader.outerHeight())
            });
            if (scrollTop > 150 && showing == false) {
                showing = true;
                $flyingButton
                    .stop(true, true)
                    .velocity({
                        "opacity": 1
                    },
                    250,
                    "easeOutQuad"
                );
                $flyingButton.addClass("button-go-top-show");
            } else if (scrollTop <= 150 && showing == true) {
                showing = false;
                $flyingButton
                    .stop(true, true)
                    .velocity({
                        "opacity": 0
                    },
                    250,
                    "easeOutQuad",
                    function () {
                        if (showing == true) {
                            return;
                        }
                        $flyingButton.removeClass("button-go-top-show");
                    }
                );
            }
        });

        $(".js-button-go-top").on("click", function () {
            $('html, body').animate({
                scrollTop: 0
            }, 150);
        });

        $(window).scroll();
    };

    module.togglePanelScreenRightSide = function (context) {
        context.andFind(".js-toggle-cart-panel").on("click.cartPanel", function (e, forceFlag) {
            e.preventDefault();

            var clickedBtn = $(this);
            var $cartPanel = $(".js-cart-sliding-panel");

            function closePanel(closeFromMenu) {
                $cartPanel
                    .stop()
                    .removeClass("panel-screen-right-side-show");

                $("body")
                    .off("click.notCartClick")
                    .parent()
                    .removeClass("panel-opened");

                $cartPanel.off("click.cartClick");

                if (!closeFromMenu) {
                    clickedBtn.removeClass('active-submenu-header active');
                }
            }

            function addNotPanelClickEvent() {
                $cartPanel
                    .off("click.cartClick")
                    .on("click.cartClick", function (e) {
                        e.stopPropagation();
                    });

                $("body")
                    .off("click.notCartClick")
                    .on("click.notCartClick", function () {
                        closePanel(false);
                    });
            }

            if ($cartPanel.hasClass("panel-screen-right-side-show")) {
                if (forceFlag == "forceopen") {
                    return;
                }

                closePanel(true);
            } else {
                closeOpenedActiveMenuItem();

                if (forceFlag == "forceclose") {
                    return;
                }

                $("body")
                    .parent()
                    .addClass("panel-opened");

                $cartPanel
                    .stop()
                    .addClass("panel-screen-right-side-show");

                setTimeout(function () {
                    addNotPanelClickEvent($cartPanel);
                }, 0);

            }
        });

        context.andFind(".js-cart-continue-shopping").on("click", function (e) {
            e.preventDefault();
            $('.js-toggle-cart-panel').first().trigger('click', 'forceclose');
        });
    };

    module.modalInlineEdit = function () {
        $(".js-inline-edit-button").on("click", function (e) {
            e.preventDefault();

            var modalTitle = $(this).attr("data-modal-title"),
                modalUrl = $(this).attr("data-modal-url"),
                modalInputSelector = $(this).attr("data-modal-input-selector"),
                $modal = $("<div>" + modalTitle + "</div>"),
                $textElement = $(this).parents(".js-inline-edit").find(".js-inline-edit-text"),
                text = $textElement.text();

            $modal.openModal({
                url: modalUrl,
                templateId: "modal-template",
                onLoad: function () {
                    var $modalEditButton = $(".js-modal-edit-button");
                    $(modalInputSelector)
                        .val(text)
                        .focus()
                        .on("keyup", function (e) {
                            if (e.keyCode == 13 || e.which == 13) {
                                e.preventDefault();
                                $modalEditButton.click();
                            }
                        });
                    $modalEditButton.on("click", function (e) {
                        e.preventDefault();
                        $textElement.text($(modalInputSelector).val());
                    });
                }
            });
        });
    };

    module.registerPasswordShow = function () {
        $(".js-sh-show-password").on("mouseup touchend", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $passwordToggleButton = $(".js-sh-password-to-toggle"),
                currentState = $passwordToggleButton.attr("type");
            $passwordToggleButton.attr("type", "password");
        });

        $(".js-sh-show-password").on("mousedown touchstart", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $passwordToggleButton = $(".js-sh-password-to-toggle"),
                currentState = $passwordToggleButton.attr("type");
            $passwordToggleButton.attr("type", "text");
        });
    };

    module.onClickShowLogin = function (context) {
        context.andFind('.js-show-login').on('click', function (e) {
            e.preventDefault();
            if ($('html').hasClass('login-showing')) {
                closeLoginOrRegister();
            } else {
                closeOpenedActiveMenuItem();
                removeLoginAndRegisterFlags();
                showLogin();
            }
        });

        context.andFind('.js-close-login, .js-show-login-resp').on('click', function (e) {
            e.preventDefault();
            $('.js-show-login').first().trigger('click');
        });
    }

    module.onClickShowRegister = function (context) {
        context.andFind('.js-show-register').on('click', function (e) {
            e.preventDefault();

            removeLoginAndRegisterFlags();
            showRegister();
        });
    }

    module.showLoginOrResiterOnPageLoad = function () {
        var $body = $('body');
        if ($body.hasClass('unautentificated')) {
            if ($body.hasClass('js-checkout-unautentificated')) {
                $body.removeClass('js-checkout-unautentificated');
                setLoginAndRegisterCheckoutMode();
            }

            showLogin();

            $body.removeClass('unautentificated');
        }

        if ($body.hasClass('unregistered')) {
            showRegister();

            $body.removeClass('unregistered');
        }
    };

    module.loginRegisterToggle = function (context) {
        context.andFind(".js-toggle-login-register").on("click", function (e) {
            e.preventDefault();

            var $html = $('html');
            if ($html.hasClass('login-showing')) {
                if ($('.js-sh-register-section').hasClass('js-active-header-item')) {
                    closeLoginOrRegister();
                    showLogin();
                } else {
                    closeLoginOrRegister();
                    showRegister();
                }
            }
        });
    };

    module.loginAndRegisterForDressingRoom = function (context) {
        context.andFind('.js-login-room').on('click', function (e) {
            e.preventDefault();

            removeLoginAndRegisterFlags();
            setLoginAndRegisterDressingRoomMode();

            showLogin();
        });

        context.andFind('.js-register-room').on('click', function (e) {
            e.preventDefault();

            removeLoginAndRegisterFlags();
            setLoginAndRegisterDressingRoomMode();

            showRegister();
        });
    };

    module.stickyInPageNav = function () {
        var $navWrapper = $(".js-in-page-navigation");

        if ($navWrapper.length == 0) {
            return;
        }

        $(window).on("scroll", function () {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > 0) {
                $navWrapper.addClass("sticky");
            } else {
                $navWrapper.removeClass("sticky");
            }
        });

        $(window).scroll();
    };

    module.expandCollapeBoxLists = function (context) {
        var $toggleButtons = $(".js-rb-toggle-list", context),
            $refineBoxLists = $(".js-rb-list", context);
        if ($toggleButtons.length == 0) {
            return;
        }
        $toggleButtons.on("click", function (e) {
            e.preventDefault();

            $(this).toggleClass("rb-list-open");

            //TODO: think later what to do
            //$('.rb-list-open').not($(this)).removeClass('rb-list-open').siblings('.rb-list-wrapper').stop().slideUp();

            $refineBoxLists
                .filter("[data-rb-list='" + $(this).attr("data-rb-toggle-list") + "']")
                .stop()
                .slideToggle(300);
        });
    };

    module.floatingDesignersMenu = function () {
        var floatingHeader = $('.designers-list-leters');
        if ($(window).scrollTop() + $(window).height() > $(document).height() - 300) {
            floatingHeader.addClass('fix-pos');
        } else {
            floatingHeader.removeClass('fix-pos');
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 300) {
                floatingHeader.addClass('fix-pos');
            } else {
                floatingHeader.removeClass('fix-pos');
            }
        });
    };

    module.primitiveSlider = function () {
        var slider,
            slideLeft = $('.js-about-slide-left'),
            slideRight = $('.js-about-slide-right');
        slider = $(".js-primitive-slider").bxSlider({
            auto: true,
            controls: false,
            mode: 'fade',
            slideSelector: 'li'
        });

        slideLeft.on("click", function (e) {
            e.preventDefault();
            slider.goToPrevSlide();
        });
        slideRight.on("click", function (e) {
            e.preventDefault();
            slider.goToNextSlide();
        });
    };

    module.hashScroll = function () {
        $('.js-hash-scroll').on('click', function (e) {
            e.preventDefault();

            var target = this.hash,
                menuConstant;

            if (viewport().width <= 768) {
                menuConstant = -51;
            }
            else {
                menuConstant = -1;
            }
            target = $(target);
            if (history && history.replaceState) {
                history.replaceState({}, "", target.selector);
                if (this.hash !== '') {
                    $('html, body')
                        .stop(true, true)
                        .animate({
                            'scrollTop': target.offset().top - menuConstant
                        }, 300, 'swing', function () {
                        });
                }
            } else {
                location.hash = href;
            }
        });
    };

    module.customUploadButton = function () {
        $('.js-button-file-upload-input').on('change', function () {
            var val = $(this).val().split(/(\\|\/)/g).pop();
            if (val !== "") {
                $(".js-button-file-upload-text")
                    .text(val)
                    .parent()
                    .removeClass("not-selected");
            } else {
                $(".js-button-file-upload-text")
                    .text("+ Attach")
                    .parent()
                    .addClass("not-selected");
            }
        });
    };

    module.numbersOnly = function (context) {
        $('.js-numbers-only', context).keyup(function (e) {
            var self = $(this),
                maxValue = parseFloat(self.attr('max')),
                minValue = parseFloat(self.attr('min'));
            this.value = this.value.replace(/[^0-9\.]/g, '');
            self.siblings('button').removeProp('disabled');
            if (parseFloat(self.val()) <= minValue) {
                self.val(minValue);
                self.siblings('.js-qty-decrease').prop('disabled', 'disabled');
            }
            if (parseFloat(self.val()) >= maxValue) {
                self.val(maxValue);
                self.siblings('.js-qty-increase').prop('disabled', 'disabled');
            }
            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });
    };

    module.fancyNumberInput = function () {
        var maxValue = $('.js-qty-input').attr('max'),
            minValue = $('.js-qty-input').attr('min'),
            self;
        //todo duplicated selectors and selecting all buttons on one button click?
        $('.js-qty-increase').on('click', function (e) {
            if (!$(this).prop('disabled')) {
                e.preventDefault();
                $('.js-qty-decrease').removeProp('disabled');
                self = $(this);
                numberInput = self.siblings('.js-qty-input');
                currentValue = parseFloat(numberInput.val());
                newValue = currentValue + 1;
                if (newValue < maxValue) {
                    numberInput.val(newValue);
                    self.removeProp('disabled');
                }
                if (newValue == maxValue) {
                    numberInput.val(newValue);
                    self.prop('disabled', 'disabled');
                }
            }
        });
        $('.js-qty-decrease').on('click', function () {
            if (!$(this).prop('disabled')) {
                $('.js-qty-increase').removeProp('disabled');
                self = $(this);
                numberInput = self.siblings('.js-qty-input');
                currentValue = parseFloat(numberInput.val());
                newValue = currentValue - 1;
                if (newValue > minValue) {
                    numberInput.val(newValue);
                    self.removeProp('disabled');
                }
                if (newValue == minValue) {
                    numberInput.val(newValue);
                    self.prop('disabled', 'disabled');
                }
            }
        });
    };

    module.setTargetBlankForCafeOpenTableSearch = function () {
        window.onload = function () {
            var otForm = document.getElementById('OT_form'),
                maxTimes = 40;
            while (otForm === undefined && maxTimes > 0) {
                setTimeout(function () {
                    otForm = document.getElementById('OT_form');
                    --maxTimes;
                }, 100);
            }
            if (!(otForm == null) && maxTimes != -1) {
                otForm.setAttribute('target', '_blank');
            }
        };
    };

    module.mobileNextSectionToggle = function () {
        var $sectionButtons = $(".js-mobile-next-section-toggle");
        $sectionButtons.on("click", function (e) {
            e.preventDefault();

            var that = $(this);
            if (that.hasClass('toggle-active')) {
                that.removeClass('toggle-active')
                    .next('section').removeClass("active");
            } else {
                $sectionButtons.removeClass('toggle-active');
                that.addClass('toggle-active');
                $sectionButtons.siblings('section').removeClass("active");
                $(this).next('section').addClass("active");
                setTimeout(function () {
                    $("html, body")
                        .stop()
                        .animate({
                            scrollTop: that.offset().top - 62
                        }, 300);
                }, 20);
            };



        });
    };

    module.cafeDatepicker = function () {
        $(".js-cafe-date-picker").Zebra_DatePicker({
            readonly_element: true,
            show_select_today: false,
            show_clear_date: true,
            format: "m/d/Y",
            direction: [true, 90],
            offset: [-120, 270],
            onSelect: function (views, elements) {
                $('.js-field-for-date-input').val(views);
                $(".js-cafe-date-picker").valid();
            }
        });
    };

    module.openTableForm = function () {
        $('.js-restaurant-time-dropdown').on('change', function () {
            document.getElementById('ResTime').value = $(this).val();
        });
        $('.js-restaurant-person-count-dropdown').on('change', function () {
            document.getElementById('PartySize').value = $(this).val();
        });
    };

    module.toggleCafeMenu = function () {
        $(".js-cafe-menu-button").on("click", function (e) {
            e.preventDefault();
            var $cafeMenu = $(".js-cafe-menu");
            $cafeMenu
                .addClass("show");
            $(this)
                .hide();

            setTimeout(function () {
                $("html, body")
                    .stop()
                    .animate({
                        scrollTop: $cafeMenu.offset().top - 70
                    }, 300);
            }, 20);
        });
    };

    module.activeSubmenuHeader = function (context) {
        $('.header-custom-tooltip', context).on('click', function (e) {
            var self = $(this);

            if (self.siblings('.sh-nav-second-level').length) {
                e.preventDefault();
            }

            $('.active-submenu-header').not(self).removeClass('active-submenu-header');
            if (self.hasClass('active-submenu-header')) {
                self.removeClass('active-submenu-header');
            } else {
                self.addClass('active-submenu-header');
            }
        });
    }

    module.jobApplicationSubmit = function () {
        var form = $("#js-career-form"),
            messagesContainer = form.find('.js-messages'),
            lock;

        $('.js-career-form-submit-button').on('click', function (e) {
            e.preventDefault();
            if (form.valid()) {
                lock = core.ui.lock('container', form);
                form.ajaxSubmit({
                    type: "POST",
                    success: function (response) {
                        if (response.Messages != null && response.Messages.length > 0) {
                            core.ui.showMessages(messagesContainer, response.Messages);
                        } else {
                            core.ui.showMessages(messagesContainer);
                        }
                        if (response.Notification) {
                            core.ui.alert('{ title: \'' + response.Notification.Title + '\', message: \'' + response.Notification.Message + '\' }');
                        }
                        if (response.Success) {
                            form.find(':input').val('');
                            form.find('.js-button-file-upload-text')
                                .text('+ Attach')
                                .parent()
                                .addClass('not-selected');
                        }
                        core.ui.unlock(lock);
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        core.ui.alert('{ title: \'Error\', message: \'' + errorThrown + '\' }');
                    }
                });
            }
            return false;
        });
    };

    module.announcementsTrigger = function (context) {
        var bodyWrapper = $(window),
            pageWrapper = $('.page-wrapper'),
            headerShow = function (className) {
                if ($(document).scrollTop() > 50) {
                    pageWrapper.removeClass(className);
                }
                else {
                    pageWrapper.addClass(className);
                }
            };

        if ($('.announcements-active-content').length) {
            headerShow('announcement-header-active');
            bodyWrapper.on('scroll', function () {
                headerShow('announcement-header-active');
            });
        };

        if ($('.announcement-header').length) {
            headerShow('announcement-cms-header-active');
            bodyWrapper.on('scroll', function () {
                headerShow('announcement-cms-header-active');
            });
        };
    };

    module.mobileExceptions = function () {
        var $siteHeader = $(".js-site-header");
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            $(document).on('focus', 'textarea, input, select', function () {
                $siteHeader.css('position', 'absolute');
            }).on('blur', 'textarea, input, select', function () {
                $siteHeader.css('position', '');
            });
        }
    };

    module.onClickReturnBack = function () {
        var $backButton = $('.js-return-back');
        $backButton.css('visibility', window.document.referrer ? 'visible' : 'hidden');

        $backButton.click(function (e) {
            e.preventDefault();
            window.history.back();
        });
    };

    module.detailsAddToBag = function () {
        var addItemToCartForm = $('.js-add-item-to-cart-form');
        var sizeField = addItemToCartForm.find('.js-product-details-sizes:input');
        var messagesContainer = addItemToCartForm.find('.js-messages');

        addItemToCartForm.find('.js-add-to-bag-button').on("click", function (e) {
            e.preventDefault();

            var sizeValue = sizeField.val();
            if (sizeValue != "" && sizeValue != "0") {
                addItemToCartForm.submit();
            } else {
                core.ui.showMessages(messagesContainer, ["Please select size."]);
            }
        });
    };

    module.toggleSmallCartButtons = function (context) {
        context.andFind(".js-small-cart-button").on("click", function (e) {
            e.preventDefault();
            var $cartItem = $(this).parents(".js-small-cart-product"),
                $smallCart = $(this).parents(".js-in-panel-products");

            $(this)
                .toggleClass("button-on");
            $cartItem
                .toggleClass("active");

            if ($cartItem.position().top + $cartItem.outerHeight() > $smallCart.outerHeight()) {
                $smallCart
                    .animate({
                        scrollTop: $smallCart.scrollTop() + ($cartItem.position().top + $cartItem.outerHeight() - $smallCart.outerHeight())
                    }, 150);
            }
        });
    };

    module.changeCartCheckoutButtonActionInCheckoutSummaryPage = function (context) {
        var submitCheckoutSummaryButton = context.andFind('.js-submit-checkout-summary');
        if (submitCheckoutSummaryButton.length) {

            //In checkout summary page, sidebar "Check out" button also should start checkout process
            context.andFind('.js-small-cart-checkout-button').on('click', function (e) {
                e.preventDefault();
                submitCheckoutSummaryButton.click();
                $('.js-toggle-cart-panel').first().trigger('click', 'forceclose');
            });
        } else { //Go to link and lock screen for other cases
            context.andFind('.js-small-cart-checkout-button').on('click', function (e) {
                core.ui.lock('screen', undefined, true);
            });
        }
    };

    module.onCheckoutSummaryGiftWrapClicked = function (context) {
        context.andFind('.js-checkout-summary-gift-wrap').click(function (e) {
            var $this = $(this);
            var url = $this.prop('checked') ? $this.data('checked-url') : $this.data('unchecked-url');
            $this.data('url', url);
            core.dom.doAction(this);
        });
    }

    module.onCheckoutAddressStepActions = function (context) {
        $(context).find('.js-checkout-profile-address-button').on('click', function (e) {
            e.preventDefault();

            var self = $(this);
            var selfWasSelected = self.hasClass('selected');

            $('.js-checkout-profile-address-button').removeClass('selected');

            if (!selfWasSelected) {
                self.addClass('selected');
            }
        });

        $(context).find('.js-checkout-address-select-payment-profile-form').submit(function (e) {
            e.preventDefault();

            var selectedProfileAddressButton = $('.js-checkout-profile-address-button.selected');
            $('.js-checkout-profile-address-hash-id').val(selectedProfileAddressButton.length ? selectedProfileAddressButton.data('address-hash-id') : "0");

            core.dom.doAction($(this));
        });
    }

    module.onCheckoutShippingOptionRadioSelected = function (context) {
        $(context).find('.js-checkout-shipping-option-radio').on('click', function () {
            var $thisParentDiv = $(this).parents('.js-checkout-shipping-option-div');
            if (!$thisParentDiv.hasClass('active')) {
                $('.js-checkout-shipping-option-div').removeClass('active');
                $thisParentDiv.addClass('active');
                core.dom.doAction(this);
            }
        });
    }

    module.onCheckoutPaymentStepActions = function (context) {
        $(context).find('.js-checkout-payment-profile-button').on('click', function (e) {
            e.preventDefault();

            var self = $(this);
            var selfWasSelected = self.hasClass('selected');

            $('.js-checkout-payment-profile-button').removeClass('selected');

            var paymentProfileCcv = $('.js-payment-profile-ccv');

            if (!selfWasSelected) {
                self.addClass('selected');
                paymentProfileCcv.show();
            } else {
                paymentProfileCcv.hide();
            }
        });

        $(context).find('.js-checkout-payment-select-payment-profile-form').submit(function (e) {
            e.preventDefault();

            var selectedProfileAddressButton = $('.js-checkout-payment-profile-button.selected');
            var selectedPaymentProfileId = selectedProfileAddressButton.length ? selectedProfileAddressButton.data('payment-profile-id') : "0";

            if (selectedPaymentProfileId == "0") {
                core.ui.showMessages($(this).find('.js-messages'), ["Please select existing card or add new one."]);
            } else {
                $('.js-checkout-payment-profile-id').val(selectedPaymentProfileId);
                core.dom.doAction($(this));
            }
        });

        function guessCreditCardType(cardNumber) {
            //First digit must be a 4.
            if (cardNumber.length >= 1 && cardNumber[0] == '4') {
                return "visa"; //Visa
            }

            //First digit must be a 5 and second digit must be in the range 1 through 5 inclusive.
            //First digit must be 2 and second digit must be in the range 2 through 7 inclusive.
            if (cardNumber.length >= 2 &&
                (cardNumber[0] == '5' && cardNumber[1] >= 1 && cardNumber[1] <= 5 ||
                 cardNumber[0] == '2' && cardNumber[1] >= 2 && cardNumber[1] <= 7)) {
                return "master-card"; //MasterCard
            }

            //First digit must be a 3 and second digit must be a 4 or 7.
            if (cardNumber.length >= 2 && cardNumber[0] == '3' && (cardNumber[1] == 4 || cardNumber[1] == 7)) {
                return "american-express"; //American Express
            }

            //First 8 digits must be in one of the following ranges:
            //60110000 through 60119999
            //65000000 through 65999999
            //62212600 through 62292599 
            if (cardNumber.length >= 8 && (cardNumber.substr(0, 8) >= 60110000 && cardNumber.substr(0, 8) <= 60119999 ||
                cardNumber.substr(0, 8) >= 65000000 && cardNumber.substr(0, 8) <= 65999999 ||
                cardNumber.substr(0, 8) >= 62212600 && cardNumber.substr(0, 8) <= 62292599)) {
                return "discover"; //Discover
            }

            //Pre-guess discover
            if (cardNumber.length < 8 && cardNumber.length >= 2 &&
                    (cardNumber.substr(0, 2) == "60" || cardNumber.substr(0, 2) == "62" || cardNumber.substr(0, 2) == "65")) {
                return "discover"; //Discover
            }

            return ""; //Not supported
        }

        context.andFind('.js-checkout-card-number-field').on('keyup input change paste mouseup', function () {
            var cardNumber = $(this).val();
            var cardTypeSpan = $('.js-checkout-card-type');
            var cardType = guessCreditCardType(cardNumber);
            if (cardType) {
                if (!cardTypeSpan.hasClass(cardType)) {
                    cardTypeSpan.addClass(cardType);
                }
            } else {
                cardTypeSpan.removeClass('visa').removeClass('master-card').removeClass('american-express').removeClass('discover');
            }
        });
    }

    module.triggerPayment = function (context) {
        var paymentType,
            triggerSelectors = $(context).andFind('.js-payment-trigger');

        var checkState = function () {
            paymentType = $(context).andFind('.js-payment-trigger').filter(':checked').val();
            if (paymentType === "paypal") {
                triggerSelectors.closest('.checkout-section-inner').addClass('paypal-active');
            } else {
                triggerSelectors.closest('.checkout-section-inner').removeClass('paypal-active');
            }
        }
        checkState();
        triggerSelectors.on('change', function () {
            checkState();
        });
    };

    module.onCheckoutIAgreeChecked = function (context) {
        $(context).andFind('.js-checkout-i-agree-checkbox').click(function (e) {
            var $this = $(this);
            if ($this.prop('checked')) {
                e.preventDefault();
                $.openModal({ url: $this.data('modal-url'), className: 'checkout-i-agree-modal', closeOnBlur: false, closeOnEscape: false });
            }
        });
    }

    module.onCheckoutIAgreeContinueClicked = function (context) {
        $(context).andFind('.js-checkout-i-agree-continue-button').click(function () {
            $('.js-checkout-i-agree-checkbox').prop('checked', true);
            $.closeModal(true);
        });
    }

    module.onSearchAutocompleteAndSubmit = function (context) {
        var $autocompleteField = context.andFind(".js-shop-search-field");
        var $appendTo = context.andFind(".js-shop-search-parent.autocomplete-wrapper-search");
        var $originalAutocomlpeteForm = context.andFind('.js-autocomplete-form');

        var typeDesigner = $originalAutocomlpeteForm.data('type-designer');
        var typeCategory = $originalAutocomlpeteForm.data('type-category');
        var typeColor = $originalAutocomlpeteForm.data('type-color');
        var typeSize = $originalAutocomlpeteForm.data('type-size');

        function loadAutocompleteKeywords($form, doneCallback) {
            $.ajax($form.attr('action'), { type: 'GET', data: $form.serialize() })
                .done(function (response) {
                    doneCallback(response);
                })
                .fail(function (response) {
                    console.log("FAILED: load search keywords");
                });
        }

        function getQueryKeywords() {
            var oneSpaceQeury = $autocompleteField.val().replace(/\s\s+/g, ' ');
            var queryKeywords = oneSpaceQeury.split(' ');
            queryKeywords = $.grep(queryKeywords, function (value) { return value.length > 0; });

            var groupedKeywords = [];
            var initialSuggestions = autocompleteCachedListsArray[0].suggestions;

            var i;
            for (i = 0; i < queryKeywords.length; i++) {
                var j;
                var foundFromSuggestions = false;
                for (j = queryKeywords.length; j > i ; j--) {
                    var groupedKeyword = queryKeywords.slice(i, j).join(' ');
                    var foundSuggestion = $.grep(initialSuggestions, function (suggestion) {
                        return suggestion.value.toLowerCase() == groupedKeyword.toLowerCase();
                    });

                    if (foundSuggestion.length > 0) {
                        foundFromSuggestions = true;
                        groupedKeywords.push(groupedKeyword);

                        i += groupedKeyword.split(' ').length - 1;

                        break;
                    }
                }

                if (!foundFromSuggestions) {
                    groupedKeywords.push(queryKeywords[i]);
                }
            }

            var uniqueGroupedKeywords = $.unique(groupedKeywords);

            return uniqueGroupedKeywords;
        }

        function getSuggestionPrefix() {
            var autocompleteQuery = $autocompleteField.val();
            var queryKeyWords = getQueryKeywords();
            var previousKeywords = autocompleteQuery && autocompleteQuery.slice(-1) == " " //Last char is space
                    ? queryKeyWords
                    : queryKeyWords.slice(0, queryKeyWords.length - 1);

            var previousQuery = previousKeywords.length ? '<strong>' + previousKeywords.join(' ') + '</strong> ' : '';
            return previousQuery;
        }

        function fillFormByQueryAndReturnKeywordsCount(form) {
            var $otherKeywordsTemplate = form.find('.js-autocomplete-other-keywords-template');
            var $designerIdTemplate = form.find('.js-autocomplete-designer-id-template');
            var $categoryIdTemplate = form.find('.js-autocomplete-category-id-template');
            var $sizeTemplate = form.find('.js-autocomplete-size-template');
            var $colorTemplate = form.find('.js-autocomplete-color-template');

            function assignValueForTemplate($template, value) {
                var valueInput = $template.clone();
                valueInput.val(value);
                $template.before(valueInput);
            };

            var alreadyAddedCateogry = false;
            var queryKeywords = getQueryKeywords();
            var index;
            for (index = 0; index < queryKeywords.length; index++) {
                var autocompleteKeywords = (autocompleteCachedListsArray[index] || { suggestions: [] }).suggestions;
                var queryKeyword = queryKeywords[index];

                var matchAutocompleteKeywords = $.grep(autocompleteKeywords, function (keywordInfo) {
                    var keywordParts = keywordInfo.value.split(' '); //For example: Other accessory
                    return keywordInfo.value.toLowerCase() == queryKeyword.toLocaleLowerCase() ||
                        $.grep(keywordParts, function (part) { return part == queryKeyword; }).length > 0;
                });

                if (matchAutocompleteKeywords.length > 0) {
                    var machedKeydord = matchAutocompleteKeywords[0];
                    switch (machedKeydord.data.type) {
                        case typeDesigner:
                            assignValueForTemplate($designerIdTemplate, machedKeydord.data.id);
                            break;
                        case typeCategory:
                            if (alreadyAddedCateogry == false) { //NOTE: Used to react to only one category in query
                                alreadyAddedCateogry = true;
                                assignValueForTemplate($categoryIdTemplate, machedKeydord.data.id);
                            }
                            break;
                        case typeColor:
                            assignValueForTemplate($colorTemplate, machedKeydord.data.id);
                            break;
                        case typeSize:
                            assignValueForTemplate($sizeTemplate, machedKeydord.data.id);
                            break;
                    }
                } else {
                    assignValueForTemplate($otherKeywordsTemplate, encodeURIComponent(queryKeyword));
                }
            }

            $otherKeywordsTemplate.remove();
            $designerIdTemplate.remove();
            $categoryIdTemplate.remove();
            $sizeTemplate.remove();
            $colorTemplate.remove();

            return queryKeywords.length;
        }

        var queryAlreadyHasCategories = false; //NOTE: Used to react to only one category in query

        function setupAutocomplete() {
            $autocompleteField.on('keydown.loadAutocomplete', function (e) {
                if (e.which == 32) { //Space

                    var autocompleteForm = $originalAutocomlpeteForm.clone();

                    var queryKeywordsCount = fillFormByQueryAndReturnKeywordsCount(autocompleteForm);

                    queryAlreadyHasCategories = autocompleteForm.find('.js-autocomplete-category-id-template').length > 0;

                    var cacheKey = autocompleteForm.serialize();
                    var existingCachedList = autocompleteCachedListsArray[queryKeywordsCount];

                    if (!existingCachedList || existingCachedList.cacheKey != cacheKey) {
                        autocompleteCachedListsArray[queryKeywordsCount] = undefined; //Clear before loading, not to show that list while keywords not downloaded
                        loadAutocompleteKeywords(autocompleteForm, function (response) {
                            autocompleteCachedListsArray[queryKeywordsCount] = { cacheKey: cacheKey, suggestions: response ? response : [] };
                        });
                    }
                }
            });

            $autocompleteField.autocomplete({
                lookup: function (query, done) {
                    var noSuggestionsResult = { suggestions: [] };
                    var queryKeywords = getQueryKeywords();
                    var keywordsCount = queryKeywords.length + (queryKeywords.length && query == "" ? 1 : 0); //FIX: for option 'minChars: 0'
                    if (keywordsCount > 0) {
                        //Wait while autocomplete list is loaded with AJAX request
                        var triesCount = 0;
                        var intervalId = window.setInterval(function () {
                            var autocompleteList = autocompleteCachedListsArray[keywordsCount - 1];
                            if (autocompleteList) {
                                window.clearInterval(intervalId);

                                var suggestions = $.grep(autocompleteList.suggestions, function (suggestion) {
                                    var suggestionMatched = suggestion.value.toLowerCase().indexOf(query.toLowerCase()) !== -1;

                                    //NOTE: Used to react to only one category in query
                                    if (suggestionMatched && queryAlreadyHasCategories > 0 && suggestion.data.type == typeCategory) {
                                        return false;
                                    }

                                    return suggestionMatched;
                                });

                                var result = { suggestions: suggestions };
                                done(result);
                            } else {
                                if (triesCount == 35) {
                                    window.clearInterval(intervalId);
                                    done(noSuggestionsResult);
                                }
                                triesCount++;
                            }
                        }, 50);
                    } else {
                        done(noSuggestionsResult);
                    }
                },
                delimiter: ' ',
                minChars: 0,
                autoFocus: true,
                triggerSelectOnValidInput: false,
                preserveInput: false,
                deferRequestBy: 50,
                appendTo: $appendTo,
                onSelect: function (suggestion) {
                    $('.js-shop-search-form').submit();
                },
                beforeRender: function (container) {
                    var suggestionDivs = container.find('.autocomplete-suggestion');
                    suggestionDivs.each(function (index, suggestion) {
                        var $suggestionDiv = $(suggestion);
                        $suggestionDiv.html(getSuggestionPrefix() + $suggestionDiv.html());
                    });
                },
            });
        }

        //Init autocomplete
        if ($autocompleteField.length && autocompleteCachedListsArray.length === 0) {
            var initAutocompleteForm = $originalAutocomlpeteForm.clone();
            initAutocompleteForm.find('input').remove();

            loadAutocompleteKeywords(initAutocompleteForm, function (response) {
                autocompleteCachedListsArray.push({ cacheKey: initAutocompleteForm.serialize(), suggestions: response ? response : [] });
                setupAutocomplete();
            });
        }

        //Bind search form submit
        var searchForm = context.andFind('.js-shop-search-form');
        searchForm.on('submit', function (e) {
            e.preventDefault();

            var searchField = $('.js-shop-search-field');
            if (searchField.length > 0 && searchField.val()) {

                $originalAutocomlpeteForm.attr('action', $(this).attr('action'));
                fillFormByQueryAndReturnKeywordsCount($originalAutocomlpeteForm);

                $originalAutocomlpeteForm.submit();
            }
        });
    };

    module.bagCustomTooltip = function (context) {
        var toggles = context.andFind('.js-bag-custom-tooltip');

        toggles.click(function (e) {
            e.preventDefault();

            if ($(this).hasClass("tooltip-is-open")) {
                toggles.removeClass("tooltip-is-open");
            } else {
                toggles.removeClass("tooltip-is-open");
                $(this).addClass("tooltip-is-open");
            }
        });
    };

    module.hoverTrInSizesTable = function (context) {
        var left = context.andFind('.js-table-int-sizes-left').find('tr'),
            right;
        left.on("hover", function () {
            var index = $(this).index();
            console.log(index);
            right = $(this).closest('.sizeguide-secondary').find('.js-table-int-sizes-right').find('tr');
            right.eq(index + 1).toggleClass("hover");
        });
    };

    module.siteReviewSlider = function (context) {
        $('.js-cafe-slider', context).slick({
            slide: '.cafe-reviews-slide',
            adaptiveHeight: false
        });
    };

    module.profileOrdersNavigation = function (context) {
        var body = $('body');

        context.andFind('.js-profile-view-order-details-link').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            var orderId = $this.data('order-id');

            savedScrollPosition = $(window).scrollTop();

            body.addClass("history-item-is-open");
            $('.js-order-history-list').addClass('hide-container');
            $('.js-order-history-item[data-order-id="' + orderId + '"]').removeClass('hide-container');

            var $navigation = $('.js-profile-navigation');
            if (!core.ui.isElementInViewport($navigation, true)) {
                $(window).scrollTop($navigation.offset().top);
            }
        });

        context.andFind('.js-profile-back-to-orders-link').click(function (e) {
            e.preventDefault();

            body.removeClass("history-item-is-open");
            $('.js-order-history-item').addClass('hide-container');
            $('.js-order-history-list').removeClass('hide-container');

            if (savedScrollPosition) {
                $(window).scrollTop(savedScrollPosition);
            }
        });
    };

    module.onShareLinkClicked = function (context) {
        context.andFind('.js-share-link').click(function (e) {
            e.preventDefault();

            window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,height=430,width=500');
        });
    }


    //designers page scrolling
    module.checkHeaderPos = function (scrollFromElement) {
        var windowY = $(window).scrollTop(),
            scrollLength,
            headerElementContainer = $('.js-sticky-element-container'),
            stickyElement = headerElementContainer.find('.js-filter-container'),
            bodyWrap = $(scrollFromElement);

        if (bodyWrap.length) {
            if (!scrollFromElement) {
                scrollLength = 0;
            } else {
                scrollLength = bodyWrap.offset().top + bodyWrap.height() - $(window).scrollTop();
            }
        }
        if (windowY > scrollLength) {
            headerElementContainer.addClass('is-sticky');
            $('.active-information').removeClass('active-information');
        } else {
            if (typeof scrollLength !== "undefined") {
                headerElementContainer.removeClass('is-sticky');
            }
        }
    };

    module.checkContainerIsSticked = function (context) {
        module.checkForBannerWrapper('.js-sticky-element-container');

        $(window).on('scroll resize', function () {
            module.checkForBannerWrapper('.js-sticky-element-container');
        });
    };

    module.checkForBannerWrapper = function () {
        module.checkHeaderPos('.js-sticky-element-container');
    };

    module.showDesignersLegend = function (context) {
        var self,
            activeClass = 'active-information';
        $('.js-show-legend', context).on('click', function () {
            self = $(this);
            if (self.hasClass('active-information')) {
                self.removeClass('active-information');
            }
            else {
                self.addClass('active-information');
            }
        });
    };

    module.designersFilterToggler = function (context) {
        var self,
            triggerClass = 'active-information',
            activeFilterClass = 'active-filter',
            parentWrapper = $('html');
        $('.js-open-filtering', context).on('click', function () {
            self = $(this);
            if (self.hasClass(triggerClass)) {
                parentWrapper.removeClass(activeFilterClass);
                self.removeClass(triggerClass);
            } else {
                parentWrapper.addClass(activeFilterClass);
                self.addClass(triggerClass);
            }
        });
    };

    module.onRemoveFromDressingDialog = function (context) {
        context.andFind('.js-dressing-room-remove').click(function (e) {
            e.preventDefault();

            var lastModal = $.getLastModal();
            if (lastModal) {
                if ($('.js-featured-looks-slider').length) {
                    $('.js-featured-looks-slider').slick("slickSetOption", "draggable", false, false);

                    var originalCloseFunction = lastModal.options.onClose;
                    lastModal.on('close', function () {
                        originalCloseFunction();
                        $('.js-featured-looks-slider').slick("slickSetOption", "draggable", true, true);
                    });
                }
            }
        });
    }

    //Issue was that in home page after input is loosing focus scroll jumps to page top
    //This is somehow caused by homepage content, if content is commented then it works fine.
    module.fixAndroidChromeHomePageNewsletterEmailScrollJumpToTop = function(context) {
        if ($('.home-page-layout').length) {
            context.andFind('.js-subscribe-newsletter-email').on('focusin', function () {
                newsletterEmailPosition = $(window).scrollTop();
            });

            context.andFind('.js-subscribe-newsletter-email').on('focusout', function () {
                if (isAndroidChrome && newsletterEmailPosition) {
                    setTimeout(function () {
                        $(window).scrollTop(newsletterEmailPosition);
                    }, 500);
                }
            });
        }
    };

    module.relatedProductsSlide = function (context) {
        var sliderWrapper = $('.js-related-products-slide', context);
        sliderWrapper
            .on('init', function () {
                $('.looks-carousel-before-init').removeClass('looks-carousel-before-init');
            })
            .on('afterChange', function (slick, currentSlide) {
                $('.active-slide').addClass('active-slide');
                $(currentSlide).addClass('active-slide');
            });

        sliderWrapper.slick({
            nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
            prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>',
            slidesToShow: 4,
            swipeToSlide: true,
            responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '27%',
                    nextArrow: '<button class="slider-arrow-right js-slider-arrow-right">Slide next</button>',
                    prevArrow: '<button class="slider-arrow-left js-slider-arrow-left">Slide prev</button>'
                }
            }]
        });
    };

    core.scopes.on("updateCartIconValue", function (event, itemsCount, context) {
        var $cartIcon = $('.js-cart-item-count-icon');
        $cartIcon.attr('data-cart-items', itemsCount);
        if (itemsCount == 0) {
            $cartIcon.addClass('empty');
            $('.js-cart-empty-message').removeClass('hide-container');
            $('.order-canceling').addClass('hide-container');
        } else {
            $cartIcon.removeClass('empty');
            $('.js-cart-empty-message').addClass('hide-container');
            $('.order-canceling').removeClass('hide-container');
        }
    });

    core.scopes.on("updateCartPriceValue", function (event, data, context) {
        $('.js-products-checkout-field').each(function () {
            $(this)[0].innerHTML = data;
        });
        $('.js-products-price-field').each(function () {
            $(this)[0].innerHTML = "Subtotal " + data;
        });
    });

    core.scopes.on("removeItemFromCart", function (event, data, context) {
        $($('.js-details-product-cart').find(data)[0]).remove();
        $('.js-checkout-product-list').find(data).sort(function (a, b) {
            return $(a).hasClass('js-out-of-stock-item') ? 0 : 1;
        }).each(function () {
            $(this).remove();
            // cause only one item should be removed from cart
            return false;
        });
    });

    core.scopes.on("openRightSideSmallCart", function (event, data, context) {
        $(".js-details-positive-action")
            .addClass("positive-action-show")
            .parents(".js-details-product-cart")
            .addClass("action-visible");

        $('.js-toggle-cart-panel').first().trigger('click', 'forceopen');

        setTimeout(function () {
            $(".js-details-positive-action")
                .removeClass("positive-action-show")
                .parents(".js-details-product-cart")
                .removeClass("action-visible");
        }, 2000);
    });

    core.scopes.on("openCheckoutLogin", function (event, data, context) {
        //login-showing means that login/register was opened from checkout summary page clicking on login icon 
        //and now this code is called from checkout sidebar "Check out" button click
        if ($('html').hasClass('login-showing')) {
            closeLoginOrRegister();
        }

        removeLoginAndRegisterFlags();
        setLoginAndRegisterCheckoutMode();

        showLogin();
    });

    core.scopes.on("setCheckoutStepProcessed", function (event, stepSelector, context) {
        $(stepSelector).removeClass('active').addClass('processed');
    });

    core.scopes.on("setCheckoutActiveStep", function (event, stepSelector, context) {
        $('.checkout-section').removeClass('active');
        $(stepSelector).removeClass('processed').addClass('active');
        $('.checkout-section.active ~ .checkout-section').removeClass('processed');

        core.ui.scrollTo(stepSelector);
    });

    core.scopes.on("setCheckoutReview", function (event, set, context) {
        if (set) {
            $('.js-checkout-steps').addClass('review');
            $('.js-card-ccv').val(''); //Clear CCV number
            $('html, body').scrollTop($('.js-checkout-step-review').offset().top);
        } else {
            $('.js-checkout-steps').removeClass('review');
        }
    });

    core.scopes.on("updateCartTotals", function (event, prices, context) {
        $('.js-shipping-amount').html(prices.shippingAmountText);
        $('.js-total-amount').html(prices.totalAmountText);
    });

    core.scopes.on("addedToDressingRoom", function (event, data, context) {
        var actionText = data.removed ? "negative" : "positive";
        var selector = ".js-dressing-room-" + data.poNumber + "-" + data.dupId + "-" + actionText + "-action";

        $(selector).addClass(actionText + "-action-show");

        if (data.removed) {
            $(selector).parent('.product-box').removeClass('added-to-dressing-room'); //For product gallery
            $(selector).parent('.look-details-container').removeClass('added-to-dressing-room'); //For look details
        } else {
            $(selector).parent('.product-box').addClass('added-to-dressing-room'); //For product gallery
            $(selector).parent('.look-details-container').addClass('added-to-dressing-room'); //For look details
        }

        var $dressingRoomIcon = $('.js-dressing-room-icon');
        $dressingRoomIcon.attr('data-cart-items', data.count);
        if (data.count == 0) {
            $dressingRoomIcon.addClass('empty');
        } else {
            $dressingRoomIcon.removeClass('empty');
        }

        $('.dressing-room-item').parent().removeClass('hide-container');
        $('.js-details-add-to-dressing-room-div').addClass('hide-container');
        $('.js-details-added-to-dressing-room-div').removeClass('hide-container');

        setTimeout(function () {
            $(selector).removeClass(actionText + "-action-show");
        }, 2000);
    });

    core.scopes.on("showNewsletterSubscriptionCompletedMessage", function (event, alreadySubscribed, context) {
        var $messageContainer = $(alreadySubscribed ? '.js-subscription-existing-message' : '.js-subscription-succeed-message');
        $messageContainer.addClass('active');

        var $emailField = $('.js-subscribe-newsletter-email');
        $emailField.val('');

        //This fixes webkit autocomplete background color
        $emailField.after($emailField.clone());
        $emailField.remove();

        setTimeout(function () {
            $messageContainer.removeClass('active');
        }, 8000);
    });

    function init() {
        module.homePageImagesLazyLoad();

        module.flyingSidebar();
        module.flyingToTopButton();

        module.modalInlineEdit();

        module.registerPasswordShow();

        module.stickyInPageNav();

        module.responsiveMenuTrigger();
        module.showLoginOrResiterOnPageLoad();

        module.numbersOnly();
        module.fancyNumberInput();
        module.customUploadButton();
        module.setTargetBlankForCafeOpenTableSearch();

        module.hashScroll();
        module.primitiveSlider();
        module.cafeDatepicker();

        module.mobileNextSectionToggle();

        module.openTableForm();
        module.toggleCafeMenu();

        module.detailsAddToBag();

        module.onClickReturnBack();
        module.jobApplicationSubmit();

        //module.mobileExceptions();
    };

    // Initialize
    $(document).ready(function () {
        init();
        core.scopes.addHandler('*', function (context) {
            module.shareTriggerWidget(context);
            module.onJsActionDoNotPreventDefault(context);
            module.togglePanelScreenRightSide(context);
            module.toggleSmallCartButtons(context);
            module.changeCartCheckoutButtonActionInCheckoutSummaryPage(context);
            module.onCheckoutSummaryGiftWrapClicked(context);
            module.expandCollapeBoxLists(context);
            module.checkHeaderIsSticked(context);
            module.checkContainerIsSticked(context);
            module.showDesignersLegend(context);

            module.onClickShowLogin(context);
            module.onClickShowRegister(context);
            module.loginAndRegisterForDressingRoom(context);
            module.loginRegisterToggle(context);

            module.onCheckoutAddressStepActions(context);
            module.onCheckoutShippingOptionRadioSelected(context);
            module.onCheckoutPaymentStepActions(context);
            module.triggerPayment(context);
            module.onCheckoutIAgreeChecked(context);
            module.onCheckoutIAgreeContinueClicked(context);
            module.activeSubmenuHeader(context);
            module.triggerFooter(context);

            module.onSearchAutocompleteAndSubmit(context);
            module.siteReviewSlider(context);
            module.floatingDesignersMenu();
            module.announcementsTrigger(context);

            module.detailsImageZoom(context);

            module.featuredLooksSlider(context);
            module.lookItemsSlider(context);
            module.looksInGroupSlider(context);
            module.onLookItemSelected(context);
            module.customCheckbox(context);

            module.checkHomeLogoVisible(context);
            module.bagCustomTooltip(context);
            module.hoverTrInSizesTable(context);

            module.profileOrdersNavigation(context);
            module.onShareLinkClicked(context);
            module.homeSliding(context);
            module.mobileNavigation(context);
            module.designersFilterToggler(context);
            module.onRemoveFromDressingDialog(context);
            module.fixAndroidChromeHomePageNewsletterEmailScrollJumpToTop(context);
            module.relatedProductsSlide(context);
        });
    });

    return module;
});
